import { Box, IconButton, Menu } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "../../../../../../../../components/app/provider/patient/chart";
import { EditPencilIcon } from "../../../../../../../../components/svg-icons/material-icons";
import Flex from "../../../../../../../../components/Flex";
import PatientInfoBadge from "../../../../../../../../components/app/provider/patient/chart/PatientInfoBadge";

interface FlagPopUpProps {
  onEdit: () => void;
  flags: Array<{ value: string; label: string; color: string }>;
}

const FlagPopUp = ({ onEdit, flags }: FlagPopUpProps) => {
  return (
    <PopupState variant="popover" popupId="create-navbar-button-menu">
      {(menuList) => (
        <>
          <Box
            {...bindTrigger(menuList)}
            sx={{
              ...CHART_TYPOGRAPHY.body5,
              fontFamily: CHART_TYPOGRAPHY.fontFamily,
              fontWeight: CHART_TYPOGRAPHY.weight.regular,
              bgcolor: CHART_COLORS.badgeWarningBg,
              color: CHART_COLORS.badgeWarningText,
              borderRadius: "999px",
              minWidth: "20px",
              height: "18px",
              px: "6px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              userSelect: "none",
              "&:hover": { filter: "brightness(0.93)" },
              "&:active": { filter: "brightness(0.87)" },
            }}
          >
            +{flags.length - 2}
          </Box>
          <Menu
            {...bindMenu(menuList)}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: "8px",
                  border: `1px solid ${CHART_COLORS.border}`,
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                  mt: "4px",
                },
              },
            }}
          >
            <Flex
              sx={{
                flexDirection: "column",
                backgroundColor: CHART_COLORS.surfaceWhite,
                gap: "8px",
                p: "10px 12px",
                minWidth: "180px",
                maxWidth: "240px",
              }}
            >
              <Flex
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => {
                    onEdit();
                    menuList.close();
                  }}
                  sx={{
                    p: "2px",
                    color: CHART_COLORS.primary,
                    "&:hover": {
                      backgroundColor: CHART_COLORS.bgSecondaryBlue,
                    },
                  }}
                >
                  <EditPencilIcon />
                </IconButton>
              </Flex>
              <Flex
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "6px",
                }}
              >
                {flags.slice(2).map((flagItem, index) => (
                  <PatientInfoBadge
                    key={index}
                    variant="custom"
                    bgColor={flagItem.color}
                    textColor={CHART_COLORS.textLight}
                    label={flagItem.label}
                    sx={{ maxWidth: "160px" }}
                  />
                ))}
              </Flex>
            </Flex>
          </Menu>
        </>
      )}
    </PopupState>
  );
};
export default FlagPopUp;
